import ContactForm from '../components/ContactForm'

export default function Contact() {
    return (
        <section>

            <ContactForm />
        </section>
    )
}
